import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "register_container" }
const _hoisted_2 = { class: "form_container" }
const _hoisted_3 = { class: "step-container" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "phone_verification_text" }
const _hoisted_7 = {
  key: 0,
  class: "errorNotice"
}

import { ref, computed, nextTick, onBeforeMount } from 'vue';
import InputField from './resetPassword/inputField.vue';
import { getCaptchaCode, fpCheckUserExist } from '@/api/user';
import CaptchaField from '../components/captchaField.vue';
import SendOtpPopup from './resetPassword/sendOtpPopup.vue';
import ResetPasswordStep from './resetPassword/resetPasswordStep.vue';
import { useRouter } from 'vue-router';
import MainButton from '../../components/common/mainButton.vue';
import { RegisterLoginData } from '@/view/loginRegister/supportScript';
import StatusPopup from '@/components/common/statusPopup.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'resetPasswordPopup',
  props: {
    dataSet: {}
  },
  emits: ['valueChanged', 'close', 'captchaChage', 'passwordResetCompleted'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emits = __emit;
const props = __props
const router = useRouter();
const codeData = ref<any>(null);
const verificationData = ref<any>(null);
const isEmailVerified = ref(false);
const isPhoneVerified = ref(false);
const phoneValidationNotice = ref(false);
const stepsReady = ref(false);
const btnLoading = ref(false);
const phoneNumberInReset = ref('');
const captcha = ref('');
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const contactType = ref('')
const fpUuid = ref('')
const stepType = ref<'identity' | 'phone' | 'email' | 'reset'>('identity');
const steps = computed(() => {
    if (!stepsReady.value) {
        return ['identity'];
    }
    const arr = ['identity'];
    if (isPhoneVerified.value) {
        arr.push('phone');
    }
    if (isEmailVerified.value) {
        arr.push('email');
    }
    arr.push('reset');
    return arr;
});

const currentStepIndex = computed(() => {
    return steps.value.findIndex(s => s === stepType.value);
});

const getStepClass = (index: number) => {
    if (index < currentStepIndex.value) return 'done';
    if (index === currentStepIndex.value) return 'active';
    return '';
};

const goToNextStep = () => {
    const index = currentStepIndex.value;
    if (index < steps.value.length - 1) {
        stepType.value = steps.value[index + 1] as any;
    }
};

const open = () => {
    stepType.value = 'identity';
    getCaptcha();
};

// Get captcha
const getCaptcha = () => {
    getCaptchaCode().then(res => {
        codeData.value = res.data;
    });
};

// Verify user
const verifyUser = async () => {
    const params = {
        contact: phoneNumberInReset.value,
        uuid: codeData.value.uuid,
        captcha: captcha.value.trim(),
        forgetPasswordCaptcha: codeData.value.forgetPasswordCaptchaEnabled,
        fpCaptchaType: "CAPTCHA-FP-step-1"
    };
    try {
        btnLoading.value = true;
        const res = await fpCheckUserExist(params);
        btnLoading.value = false;
        if (res.code === 200) {
            showSuccess('');
            verificationData.value = res.data;
            isPhoneVerified.value = res.data?.mobileVerified || false;
            isEmailVerified.value = res.data?.emailVerified || false;
            if(isPhoneVerified.value){
                if(res.data?.smsVerified){
                    contactType.value = 'SMS';
                } else if(res.data?.whatsappVerified){
                    contactType.value = 'WHATSAPP';
                }
            } else if(isEmailVerified.value){
                contactType.value = 'EMAIL';
            }
            contactType.value = isPhoneVerified.value ? res.data?.smsVerified ? 'sms' : 'email' : 'email';
            fpUuid.value = res.data?.fpUuid || '';
            if (!isPhoneVerified.value && !isEmailVerified.value) {
                showError(res.msg);
                getCaptcha();
            } else {
                showSuccess('');
                stepsReady.value = true;
                setTimeout(() => {
                    goToNextStep();
                }, 500);
                await nextTick();
            }
        } else {
            showError(res.msg)
            getCaptcha();
        }
    } catch (err) {
        getCaptcha();
        btnLoading.value = false;
        const message = err instanceof Error ? err.message : String(err);
        showError(message);
    }
};

const onOtpVerified = async () => {
    await nextTick();
    goToNextStep();
};

const onPasswordReset = () => {
    emits('passwordResetCompleted');
};

const checkPhoneValidation = (value: string) => {
    if ((value.length === 11 && value[2] === '9') || value.length === 0) {
        phoneValidationNotice.value = false
    } else {
        phoneValidationNotice.value = true
    }
}

const phoneChange = (value: string) => {
    phoneNumberInReset.value = value
    checkPhoneValidation(value)
}

const isCaptchaValid = computed(() => {
    return captcha.value.trim().length > 0
})

const isFormValid = computed(() => {
    return (
        phoneNumberInReset.value.length === 11 &&
        phoneNumberInReset.value[2] === '9' &&
        !phoneValidationNotice.value &&
        isCaptchaValid.value
    )
})

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
};

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

onBeforeMount(() => {
    open();
})

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_row, {
              align: "center",
              justify: "space-between",
              class: "step-row"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_van_col, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["step-item", getStepClass(index)])
                        }, [
                          (index < currentStepIndex.value)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 0,
                                name: "success"
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(index + 1), 1))
                        ], 2)
                      ]),
                      _: 2
                    }, 1024),
                    (index !== steps.value.length - 1)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 0,
                          class: _normalizeClass(["line", { done: index < currentStepIndex.value }])
                        }, null, 8, ["class"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]),
          (stepType.value === 'identity')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.verifyUserID')), 1),
                _createVNode(InputField, {
                  modelValue: phoneNumberInReset.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumberInReset).value = $event)),
                  onValueChanged: phoneChange,
                  labelText: _ctx.$t('profile.phoneNum'),
                  isshowFlag: true,
                  fieldType: "number",
                  isShowError: phoneValidationNotice.value
                }, null, 8, ["modelValue", "labelText", "isShowError"]),
                (phoneValidationNotice.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_van_icon, { name: "warning-o" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('loginRegister.phoneFormat')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(CaptchaField, {
                  "captcha-img": codeData.value?.img ? 'data:image/png;base64,' + codeData.value.img : '',
                  onValueChanged: _cache[1] || (_cache[1] = ($event: any) => (captcha.value = $event)),
                  onUpdateCaptcha: getCaptcha
                }, null, 8, ["captcha-img"]),
                _createVNode(MainButton, {
                  title: _ctx.$t('common.resetPasswordNow'),
                  radius: "5px !important",
                  activeStatus: isFormValid.value,
                  onClick: verifyUser,
                  "btn-padding": "30px !important",
                  style: {"margin":"2rem 0 1rem"},
                  isBtnLoading: btnLoading.value
                }, null, 8, ["title", "activeStatus", "isBtnLoading"])
              ]))
            : _createCommentVNode("", true),
          (stepType.value === 'phone')
            ? (_openBlock(), _createBlock(SendOtpPopup, {
                key: 1,
                verificationData: verificationData.value,
                phoneNumber: phoneNumberInReset.value,
                uuid: codeData.value?.uuid,
                onVerified: onOtpVerified,
                emailVerified: isEmailVerified.value,
                phoneVerified: isPhoneVerified.value,
                stepType: stepType.value
              }, null, 8, ["verificationData", "phoneNumber", "uuid", "emailVerified", "phoneVerified", "stepType"]))
            : _createCommentVNode("", true),
          (stepType.value === 'email')
            ? (_openBlock(), _createBlock(SendOtpPopup, {
                key: 2,
                verificationData: verificationData.value,
                phoneNumber: phoneNumberInReset.value,
                uuid: codeData.value?.uuid,
                onVerified: onOtpVerified,
                emailVerified: isEmailVerified.value,
                phoneVerified: isPhoneVerified.value,
                stepType: stepType.value
              }, null, 8, ["verificationData", "phoneNumber", "uuid", "emailVerified", "phoneVerified", "stepType"]))
            : _createCommentVNode("", true),
          (stepType.value === 'reset')
            ? (_openBlock(), _createBlock(ResetPasswordStep, {
                key: 3,
                uuid: codeData.value?.uuid,
                fpUuid: fpUuid.value,
                contact: phoneNumberInReset.value,
                contactType: contactType.value,
                areaCode: '55',
                onReset: onPasswordReset
              }, null, 8, ["uuid", "fpUuid", "contact", "contactType"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value,
      transparentOverlay: true
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})